import React, { createRef } from 'react';
import { IonLoading, IonSelect, IonSelectOption, IonModal, IonTextarea, IonAlert, IonItemSliding, IonItemOptions, IonItemOption, IonToggle, IonListHeader, IonButton, IonChip, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonActionSheet, IonInput, IonButtons, IonBackButton, IonFab, IonFabButton, IonIcon, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, withIonLifeCycle, IonAvatar } from '@ionic/react';
import '../styles/Studyset.scss';
import '../styles/DropboxAuthModal.scss';
import '../styles/Settings.scss';
import Storage from '../Storage';
import SQLStorage from '../SQLStorage';
import Utilities from '../Utilities';
import TagEditorModal from './TagEditorModal';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { checkmarkCircle, headset, star, pricetag, close, volumeHigh, trash, more, add, albums, wallet, bulb, gitMerge, school, chevronForward, checkmarkDoneCircle, refresh } from 'ionicons/icons'
import store from '../state/store';
import { updatedSetsSet } from '../state/actions/UpdatedSets';
import PremiumDogoo from '../images/premium.png';
import ContactUs from './ContactUs';
import LanguagePickerModal from './LanguagePicker';
import Server from '../Server';
import Avatar from "boring-avatars";

class Settings extends React.Component {

    constructor(props) {
        super(props);
        this.pageRef = createRef();
        this.state = {
            accessToken: null,
            refreshToken: null
        }
    }

    async componentDidMount() {

        const accessToken = this.props.match.params.accessToken;
        const refreshToken = this.props.match.params.refreshToken;

        this.setState({
            accessToken: accessToken,
            refreshToken: refreshToken,
            mode: localStorage.getItem("externalAuthStarted") ? "autoinit" : "showtokens",
            loading: localStorage.getItem("externalAuthStarted")
        })

        if (localStorage.getItem("externalAuthStarted")) {
            const DropboxSDK = require('dropbox').Dropbox;
            window.dropbox.api = new DropboxSDK({ accessToken: accessToken });
    
            window.dropbox.api
                .filesListFolder({path: '', limit: 1})
                .then(async function(response) {
                    let settings = await Storage.getO("settings");
                    settings.dropbox = (settings.dropbox && settings.dropbox.key) ? settings.dropbox : { };
                    settings.dropbox.key = accessToken;
                    settings.dropbox.refreshToken = refreshToken;
                    Utilities.trackEvent("Dropbox", "Dropbox Authenticated", "Authenticated")
                    localStorage.removeItem("externalAuthStarted");
                    await Storage.setO("settings", settings);
                    localStorage.setItem("reloadOnInit", "true");
                    localStorage.setItem("preventAppOpenTrack", "true")
                    window.location.href = "/sets";
                }.bind(this)).catch(function(error) {
                    window.toast("Failed to validate code", "error");
                    this.setState({ error: true })
                    setTimeout(() => {
                        localStorage.setItem("preventAppOpenTrack", "true")
                        window.location.href = "/";
                    }, 2000)
                }.bind(this));
        }

    }

    render() {

        return (
        <IonPage data-page="settings" ref={this.pageRef}>
            <IonContent>
                { (!this.state.loading) &&
                    <div style={{ padding: 20 }} className="dropbox-init-error">
                        {/* TO DO LANG */}
                        <h2>Insert the below code into the app</h2>
                        <textarea style={{ marginTop: 20, width: '100%' }} rows={3} value={this.state.refreshToken}></textarea>
                    </div>
                }
            </IonContent>
            { (this.state.loading) &&
                <IonLoading
                    isOpen={true}
                    message={window.ln.loading}
                    duration={15000}
                />
            }
          </IonPage>
        );
    }

};


export default withIonLifeCycle(Settings);
